import { AppSettingService } from './app-setting.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Router } from "@angular/router"


@Injectable()
export class AuthGaurdService {

  constructor(private router: Router, private appSettingService: AppSettingService) { }

  canActivate(): Observable<boolean> | boolean {
    // here check if this is first time call. If not return 
    // simple boolean based on user object from authService
    // otherwise:

   // console.log("isAuthenticated",this.appSettingService.isAuthenticated)
    if (this.appSettingService.isAuthenticated) {

      return true;
    }

    this.router.navigate(['/login']);
    // this.router.navigate(['/login'], { queryParams: { returnUrl:this. state.url }});
    return false;
  }
}